export default __webpack_public_path__ + "static/media/sale.b3214eb1.png";